import { useEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import { monthsFullOptions } from "../../consts/quickbooksReports"
import { SelectDropdown } from "../SelectDropdown"
import { useClickOutsideBlock } from "../../helpers/useClickOutside";

export const DropdownByProductSettings = ({
    isOpen,
    forecastProduct,
    setForecastProducts,
    cancelClick,
    onChangeSettings,
    anchorEl,
    usePortal
}) => {
    const modalRef = useRef(null);
    const [selectedStartMonth, setSelectedStartMonth] = useState(forecastProduct?.start_month || null);
    const [selectedEndMonth, setSelectedEndMonth] = useState(forecastProduct?.end_month || null);
    // const [selectedRamp, setSelectedRamp] = useState(forecastProduct?.ramp || "none");
    // const [percentMode, setPercentMode] = useState(forecastProduct?.percent_mode || "prorate");
    useClickOutsideBlock(modalRef, cancelClick);
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const updatePosition = () => {
        if (!anchorEl) return;
        const rect = anchorEl.getBoundingClientRect();
        const dropdownWidth = (modalRef.current?.offsetWidth || 320);
        const dropdownHeight = (modalRef.current?.offsetHeight || 0);
        const margin = 8;
        let left = Math.max(margin, Math.min(rect.left, window.innerWidth - dropdownWidth - margin));
        let top = rect.bottom + margin;
        if (top + dropdownHeight > window.innerHeight - margin) {
            // flip above if not enough space below
            top = Math.max(margin, rect.top - dropdownHeight - margin);
        }
        setCoords({ top, left });
    };

    useEffect(() => {
        if (!isOpen) return;
        updatePosition();
        const onScroll = () => updatePosition();
        const onResize = () => updatePosition();
        window.addEventListener("scroll", onScroll, true);
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("scroll", onScroll, true);
            window.removeEventListener("resize", onResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, anchorEl]);

    if (!isOpen) return null;

    const content = (
        <section
            ref={modalRef}
            className="bg-white z-[1000] rounded-md border shadow-md outline-hidden w-80 p-4"
            style={usePortal ? { position: "fixed", top: `${coords.top}px`, left: `${coords.left}px` } : {}}
        >
            <div className="space-y-4">
                <div>
                    <label
                        className="flex items-center gap-2 select-none text-sm font-medium"
                    >
                        Start Month
                    </label>
                    <SelectDropdown
                        options={monthsFullOptions || []}
                        value={selectedStartMonth}
                        onChange={(val) => {
                            setSelectedStartMonth(val);
                            onChangeSettings && onChangeSettings({ start_month: val });
                        }}
                    />
                </div>
                <div>
                    <label
                        className="flex items-center gap-2 select-none text-sm font-medium"
                    >
                        End Month (Optional)
                    </label>
                    <SelectDropdown
                        options={monthsFullOptions || []}
                        value={selectedEndMonth}
                        onChange={(val) => {
                            setSelectedEndMonth(val);
                            onChangeSettings && onChangeSettings({ end_month: val });
                        }}
                    />
                </div>
                {/* <div>
                    <label
                        className="flex items-center gap-2 select-none text-sm font-medium"
                    >
                        % Mode
                    </label>
                    <div className="mt-2 flex flex-col gap-2">
                        <label className="flex items-center gap-2 select-none text-sm">
                            <input
                                type="radio"
                                name="percentMode"
                                value="prorate"
                                checked={percentMode === "prorate"}
                                onChange={() => {
                                    setPercentMode("prorate");
                                    onChangeSettings && onChangeSettings({ percent_mode: "prorate" });
                                }}
                                className="h-4 w-4 accent-black"
                            />
                            <span>Prorate by active months (default)</span>
                        </label>
                        <label className="flex items-center gap-2 select-none text-sm">
                            <input
                                type="radio"
                                name="percentMode"
                                value="preserve"
                                checked={percentMode === "preserve"}
                                onChange={() => {
                                    setPercentMode("preserve");
                                    onChangeSettings && onChangeSettings({ percent_mode: "preserve" });
                                }}
                                className="h-4 w-4 accent-black"
                            />
                            <span>Preserve annual target</span>
                        </label>
                    </div>
                </div> */}
                {/* <div>
                    <label
                        className="flex items-center gap-2 select-none text-sm font-medium"
                    >
                        Ramp (Optional)
                    </label>
                    <SelectDropdown
                        options={[
                            { label: "None", value: "none" },
                            { label: "3-month ramp (40%/70%/100%)", value: "months" }
                        ]}
                        value={selectedRamp}
                        onChange={(val) => {
                            setSelectedRamp(val);
                            onChangeSettings && onChangeSettings({ ramp: val });
                        }}
                    />
                </div> */}
            </div>
        </section>
    );

    if (usePortal) {
        return createPortal(content, document.body);
    }
    return content;
}